{
  "Clear search": "Tyhjennä haku"
}
